import Board from './Board';
import Boardt from './Boardt';
import Boardthree from './Boardthree';

export default function Valores() {
    return (
        <div className="valoresdiv">
            <h2 className="textboardp">Valores H2L </h2>
            <Boardthree />
            <Board />


            <Boardt />

        </div>
    )
}